// Español: перевод интерфейса. Ключ — русская строка из кода (t("…")).
// Собрано из всех t(...) в src/; при новых надписях — добавить сюда.
const dict = {
  "никогда": "nunca",
  "только что": "ahora mismo",
  "сегодня": "hoy",
  "вчера": "ayer",
  "{0} {1} назад": "hace {0} {1}",
  "день": "día",
  "дня": "días",
  "дней": "días",
  "навсегда": "para siempre",
  "до {0}": "hasta {0}",
  "Заблокировал": "Bloqueó",
  "Разблокировал": "Desbloqueó",
  "Выкинул со всех устройств": "Cerró sesión en todos los dispositivos",
  "Дал права админа": "Hizo administrador",
  "Снял права админа": "Quitó permisos de administrador",
  "Сменил тариф": "Cambió el plan",
  "Удалил аккаунт": "Eliminó la cuenta",
  "Объявление": "Anuncio",
  "Снял объявление": "Quitó el anuncio",
  "гость": "invitado",
  "AntonCards — ошибки ({0})": "AntonCards — errores ({0})",
  "Pro до какой даты? (ДД.ММ.ГГГГ, пусто — бессрочно)": "¿Pro hasta qué fecha? (DD.MM.AAAA, vacío — sin fin)",
  "Не понял дату — напишите, например, 31.12.2026": "No entendí la fecha — escribe, por ejemplo, 31.12.2026",
  "Тариф Pro включён": "Plan Pro activado",
  "Тариф Free": "Plan Free",
  "{0} заблокирован": "{0} bloqueado",
  "Разблокировать": "Desbloquear",
  "Разблокирован": "Desbloqueado",
  "Заблокировать…": "Bloquear…",
  "На срок или навсегда, с причиной": "Por un tiempo o para siempre, con motivo",
  "Выкинуть со всех устройств": "Cerrar sesión en todos los dispositivos",
  "Войти снова сможет": "Podrá volver a entrar",
  "Выкинуть {0} со всех устройств?": "¿Cerrar la sesión de {0} en todos los dispositivos?",
  "Выкинут со всех устройств": "Sesión cerrada en todos los dispositivos",
  "Тариф: сделать Free": "Plan: cambiar a Free",
  "Тариф: сделать Pro…": "Plan: cambiar a Pro…",
  "Снять права админа": "Quitar permisos de administrador",
  "Снять права админа у {0}?": "¿Quitar permisos de administrador a {0}?",
  "Права админа сняты": "Permisos de administrador quitados",
  "Сделать админом": "Hacer administrador",
  "Полный доступ к этой панели": "Acceso completo a este panel",
  "Дать {0} права админа? Он увидит всех пользователей и сможет блокировать.": "¿Dar permisos de administrador a {0}? Verá a todos los usuarios y podrá bloquear.",
  "Теперь админ": "Ahora es administrador",
  "Письмо для сброса пароля": "Correo para restablecer la contraseña",
  "Письмо отправлено на {0}": "Correo enviado a {0}",
  "Скопировать почту": "Copiar correo",
  "Почта скопирована": "Correo copiado",
  "Удалить аккаунт…": "Eliminar cuenta…",
  "Навсегда, со всеми данными": "Para siempre, con todos los datos",
  "Удалить аккаунт {0} и все его проекты, тексты, словарь и статистику? Это нельзя отменить.\n\nЧтобы подтвердить, введите почту:": "¿Eliminar la cuenta {0} y todos sus proyectos, textos, vocabulario y estadísticas? No se puede deshacer.\n\nPara confirmar, escribe el correo:",
  "Почта не совпала — аккаунт не удалён": "El correo no coincide — la cuenta no se eliminó",
  "Аккаунт {0} удалён": "Cuenta {0} eliminada",
  "Обзор": "Resumen",
  "Пользователи{0}": "Usuarios{0}",
  "Разборы": "Explicaciones",
  "Ошибки{0}": "Errores{0}",
  "Журнал": "Registro",
  "Админ-панель": "Panel de administración",
  "Закрыть": "Cerrar",
  "Поиск по имени или почте": "Buscar por nombre o correo",
  "Поиск": "Buscar",
  "Пользователей": "Usuarios",
  "+{0} за неделю": "+{0} esta semana",
  "Активны сегодня": "Activos hoy",
  "{0} за неделю": "{0} esta semana",
  "Заблокировано": "Bloqueados",
  "Ошибок за сутки": "Errores en 24 h",
  "Аудиопроектов": "Proyectos de audio",
  "Карточек": "Tarjetas",
  "Текстов": "Textos",
  "Слов в словарях": "Palabras en vocabularios",
  "Недавно заходили": "Activos recientemente",
  "Все пользователи": "Todos los usuarios",
  "Все": "Todos",
  "Активные 7 дн.": "Activos 7 días",
  "Новые": "Nuevos",
  "Заблокированные": "Bloqueados",
  "Админы": "Administradores",
  "Загружаю…": "Cargando…",
  "Показано:": "Mostrados:",
  ". Почты видны только админам.": ". Los correos solo los ven los administradores.",
  "Админ": "Admin",
  " до {0}": " hasta {0}",
  "Заблокирован": "Bloqueado",
  "почта не подтверждена": "correo no confirmado",
  "это вы": "eres tú",
  "был": "visto",
  "· с": "· desde",
  "аудио ·": "audio ·",
  "текст": "texto",
  "текста": "textos",
  "текстов": "textos",
  " · причина: {0}": " · motivo: {0}",
  "Действия: {0}": "Acciones: {0}",
  "Никого не нашлось.": "No se encontró a nadie.",
  "Объявление для всех пользователей": "Anuncio para todos los usuarios",
  "Появится полосой сверху главной на сайте, телефоне и компьютере. Каждый может закрыть его у себя.": "Aparece como una franja arriba de la pantalla de inicio en la web, el teléfono y el ordenador. Cada uno puede cerrarlo.",
  "Сейчас показывается:": "Se muestra ahora:",
  "Например: «Завтра с 10:00 до 10:30 — обновление, синхронизация может быть недоступна»": "Por ejemplo: «Mañana de 10:00 a 10:30 — actualización, la sincronización puede no estar disponible»",
  "Обычное": "Normal",
  "Важное": "Importante",
  "Объявление снято": "Anuncio retirado",
  "Снять": "Retirar",
  "Объявление опубликовано": "Anuncio publicado",
  "Опубликовать": "Publicar",
  "Последние 100 разборов. Удалённый разбор пропадает у всех.": "Últimas 100 explicaciones. Una explicación eliminada desaparece para todos.",
  "Разборов пока нет.": "Aún no hay explicaciones.",
  "Ученик": "Estudiante",
  " · скрыт": " · oculta",
  "Удалить разбор «{0}» от {1}?": "¿Eliminar la explicación «{0}» de {1}?",
  "Удалить": "Eliminar",
  "Ошибки с сайта, телефона и компьютера, последние 200. «Скопировать всё» — и вставьте в чат с Claude.": "Errores de la web, el teléfono y el ordenador, los últimos 200. «Copiar todo» — y pégalo en un chat con Claude.",
  "Скопировано ✓": "Copiado ✓",
  "Скопировать всё": "Copiar todo",
  "Удалить все записи журнала ошибок?": "¿Eliminar todas las entradas del registro de errores?",
  "Очистить": "Borrar",
  "Ошибок нет.": "No hay errores.",
  "Кто из админов что сделал — последние 200 действий.": "Qué hizo cada administrador — las últimas 200 acciones.",
  "Пока пусто.": "Vacío por ahora.",
  "Заблокировать": "Bloquear",
  "Человек сразу выйдет на всех устройствах и не сможет войти до конца срока. Его данные не удаляются.": "La persona saldrá de inmediato en todos los dispositivos y no podrá entrar hasta que termine el plazo. Sus datos no se eliminan.",
  "1 день": "1 día",
  "7 дней": "7 días",
  "30 дней": "30 días",
  "Навсегда": "Para siempre",
  "Причина (увидит пользователь)": "Motivo (lo verá el usuario)",
  "Причина": "Motivo",
  "Отмена": "Cancelar",
  "Активность": "Actividad",
  "Текущий год": "Este año",
  "Вс": "Dom",
  "Пн": "Lun",
  "Вт": "Mar",
  "Ср": "Mié",
  "Чт": "Jue",
  "Пт": "Vie",
  "Сб": "Sáb",
  "Прогноз 7 дней": "Pronóstico de 7 días",
  "всего": "total",
  "{0} {1}: {2} карт": "{0} {1}: {2} tarjetas",
  "Светлая тема": "Tema claro",
  "Тёмная тема": "Tema oscuro",
  "проект": "proyecto",
  "проекта": "proyectos",
  "проектов": "proyectos",
  "без языка": "sin idioma",
  "Их прослушивание/чтение не попадает в статистику по языкам.": "Su escucha y lectura no cuentan en las estadísticas por idioma.",
  "Назначить": "Asignar",
  "Назначить язык проектам": "Asignar idioma a los proyectos",
  "Выберите язык для каждой папки — он применится ко всем проектам внутри. Для папок, которые пока не хотите размечать, выберите «Пропустить».": "Elige un idioma para cada carpeta — se aplicará a todos sus proyectos. Elige «Omitir» para las carpetas que aún no quieras marcar.",
  "Готово": "Listo",
  "(Без папки)": "(Sin carpeta)",
  "— пропустить —": "— omitir —",
  "Применить": "Aplicar",
  "Какой язык вы изучаете?": "¿Qué idioma estás aprendiendo?",
  "AntonCards ведёт статистику отдельно для каждого языка.": "AntonCards lleva estadísticas separadas para cada idioma.",
  "Можно поменять в любой момент.": "Puedes cambiarlo en cualquier momento.",
  "＋ Своего нет в списке — добавить": "＋ El mío no está — añadirlo",
  "Пропустить — выберу позже": "Omitir — elegiré después",
  "Русский": "Ruso",
  "Українська": "Ucraniano",
  "Введите код языка (например, cy)": "Escribe el código del idioma (por ejemplo, cy)",
  "Код должен быть в формате BCP-47: cy, eu, nv, gd, zh-Hant…": "El código debe ser BCP-47: cy, eu, nv, gd, zh-Hant…",
  "Этот язык уже есть во встроенном списке": "Este idioma ya está en la lista",
  "«{0}» добавлен.": "«{0}» añadido.",
  "Удалить «{0}»? Карточки и статистика останутся.": "¿Eliminar «{0}»? Las tarjetas y estadísticas se conservan.",
  "Свой язык": "Idioma propio",
  "Любой BCP-47 код:": "Cualquier código BCP-47:",
  "валлийский,": "galés,",
  "баскский,": "vasco,",
  "навахо.": "navajo.",
  "Новый язык": "Nuevo idioma",
  "Код": "Código",
  "например, cy": "p. ej., cy",
  "Название": "Nombre",
  "например, Cymraeg": "p. ej., Cymraeg",
  "Флаг (эмодзи)": "Bandera (emoji)",
  "Добавить язык": "Añadir idioma",
  "Ваши языки": "Tus idiomas",
  "Изучаемый язык: главная, повторение и статистика показывают его": "Idioma que aprendes: inicio, repaso y estadísticas lo muestran",
  "Язык: {0}": "Idioma: {0}",
  "не выбран": "no elegido",
  "Язык": "Idioma",
  "Выбрать язык": "Elegir idioma",
  "Свой язык…": "Idioma propio…",
  "Нет соединения. Проверьте интернет.": "Sin conexión. Revisa internet.",
  "Сейчас нельзя отправить письмо: почтовый сервис отправляет всего несколько писем в час. Подождите час — или войдите через Google.": "Ahora no se puede enviar el correo: el servicio solo envía unos pocos correos por hora. Espera una hora o entra con Google.",
  "Почта ещё не подтверждена. Откройте письмо и перейдите по ссылке — или отправьте письмо ещё раз.": "Tu correo aún no está confirmado. Abre el mensaje y sigue el enlace — o envíalo de nuevo.",
  "Такой аккаунт уже есть. Войдите или восстановите пароль.": "Esta cuenta ya existe. Entra o restablece la contraseña.",
  "Неверный email или пароль.": "Correo o contraseña incorrectos.",
  "Пароль слишком простой — минимум 6 символов.": "Contraseña demasiado simple — mínimo 6 caracteres.",
  "В адресе почты ошибка.": "Hay un error en el correo.",
  "Регистрация по почте выключена.": "El registro por correo está desactivado.",
  "Вход через Google ещё не включён в настройках Supabase.": "El acceso con Google aún no está activado en Supabase.",
  "Ошибка": "Error",
  "Письмо отправлено ещё раз на {0}.": "Correo enviado de nuevo a {0}.",
  "Введите email": "Escribe tu correo",
  "Письмо отправлено на {0}. Откройте его и перейдите по ссылке.": "Correo enviado a {0}. Ábrelo y sigue el enlace.",
  "Нет соединения.": "Sin conexión.",
  "Заполни email и пароль": "Escribe correo y contraseña",
  "Аккаунт создан!": "¡Cuenta creada!",
  "Письмо для подтверждения отправлено на {0}. Откройте его и перейдите по ссылке. Нет письма — проверьте «Спам».": "Se envió un correo de confirmación a {0}. Ábrelo y sigue el enlace. Si no llega, revisa Spam.",
  "Пароль": "Contraseña",
  "Войдите, чтобы открыть проекты": "Entra para abrir tus proyectos",
  "Создайте аккаунт — это бесплатно": "Crea una cuenta — gratis",
  "Сбросить пароль по email": "Restablecer contraseña por correo",
  "Войти": "Entrar",
  "Создать аккаунт": "Crear cuenta",
  "Отправить письмо": "Enviar correo",
  "Аккаунт заблокирован": "Cuenta bloqueada",
  "Причина:": "Motivo:",
  "Администратор завершил ваш сеанс. Войдите снова.": "Un administrador cerró tu sesión. Vuelve a entrar.",
  "Продолжить с Google": "Continuar con Google",
  "или по почте": "o con correo",
  "name@example.com": "tu@ejemplo.com",
  "минимум 6 символов": "mínimo 6 caracteres",
  "Забыли пароль?": "¿Olvidaste la contraseña?",
  "Отправить письмо ещё раз": "Enviar el correo de nuevo",
  "Загрузка...": "Cargando...",
  "← Назад к входу": "← Volver a entrar",
  "Нет аккаунта? ": "¿No tienes cuenta? ",
  "Уже есть аккаунт? ": "¿Ya tienes cuenta? ",
  "Зарегистрироваться": "Registrarse",
  "Регистрируясь, вы соглашаетесь с": "Al registrarte, aceptas los",
  "Назад": "Atrás",
  "Квиз": "Quiz",
  "Источник": "Fuente",
  "Все проекты": "Todos los proyectos",
  "По папке": "Por carpeta",
  "Выбрать проекты": "Elegir proyectos",
  "карт.": "tarj.",
  "Направление": "Dirección",
  "Слово → Перевод": "Palabra → Traducción",
  "Перевод → Слово": "Traducción → Palabra",
  "Нет карточек": "No hay tarjetas",
  "Просмотр карточек": "Ver tarjetas",
  "Листайте все карточки": "Pasa todas las tarjetas",
  "Повторение (FSRS)": "Repaso (FSRS)",
  "Удержание": "Retención",
  "% · сегодня:": "% · hoy:",
  "нов.,": "nuevas,",
  "повт.": "repasos",
  "✓ Дневной лимит достигнут": "✓ Límite diario alcanzado",
  "{0} к повторению": "{0} para repasar",
  "Настройки FSRS": "Ajustes de FSRS",
  "% · день с": "% · el día empieza a las",
  "Стоп": "Parar",
  "Озвучка: {0}": "Leer en voz alta: {0}",
  "фронт": "anverso",
  "бек": "reverso",
  "выкл": "no",
  "Редактировать": "Editar",
  "Удержание: {0}%": "Retención: {0}%",
  "Редактировать карточку": "Editar tarjeta",
  "Слово / фраза": "Palabra / frase",
  "Перевод": "Traducción",
  "Сохранить": "Guardar",
  "повтор {0}д": "repaso {0}d",
  "обучение": "aprendiendo",
  "нажмите, чтобы перевернуть": "toca para girar",
  "Показать ответ": "Mostrar respuesta",
  "Не знаю": "No sé",
  "Трудно": "Difícil",
  "Знаю": "Sé",
  "1 · 2 · 3 — оценка, пробел — «Знаю»": "1 · 2 · 3 — valorar, espacio — «Sé»",
  "Пробел — показать ответ": "Espacio — mostrar respuesta",
  "Цель выполнена!": "¡Meta cumplida!",
  "Повторено": "Repasadas",
  "· Ещё": "· Quedan",
  "доступно": "disponibles",
  "Продолжить (": "Continuar (",
  "Выход": "Salir",
  "Сессия завершена!": "¡Sesión terminada!",
  "Следующие повторения": "Próximos repasos",
  "Ещё раз": "Otra vez",
  "Отлично!": "¡Excelente!",
  "Хорошо!": "¡Bien!",
  "Учись дальше!": "¡Sigue aprendiendo!",
  "правильно": "correctas",
  "неверно": "incorrectas",
  "Выбор режима": "Elegir modo",
  "Слово": "Palabra",
  "нажмите, чтобы увидеть перевод": "toca para ver la traducción",
  "← Назад": "← Atrás",
  "Далее →": "Siguiente →",
  "Готово ✓": "Listo ✓",
  "← тяни чтобы изменить →": "← arrastra para cambiar →",
  "с": "s",
  "{0} на {1} с": "{0} {1} s",
  "Вперёд": "Adelante",
  "Пауза": "Pausa",
  "Играть": "Reproducir",
  "Снять повтор": "Quitar repetición",
  "Зациклить последние {0} с": "Repetir los últimos {0} s",
  "Клип {0} с": "Clip {0} s",
  "Держите, чтобы слушать на {0}×": "Mantén para escuchar a {0}×",
  "Держать {0}×": "Mantener {0}×",
  "Скорость": "Velocidad",
  "Скорость {0}×": "Velocidad {0}×",
  "Открыть плеер": "Abrir reproductor",
  "Перемотка": "Avanzar/retroceder",
  "Мини-плеер": "Minirreproductor",
  "Предыдущая карточка": "Tarjeta anterior",
  "Следующая карточка": "Tarjeta siguiente",
  "Громкость": "Volumen",
  "— не использовать —": "— no usar —",
  "Слово / выражение": "Palabra / expresión",
  "Перевод / значение": "Traducción / significado",
  "Предложение с контекстом": "Frase con contexto",
  "Предложение-клоуз ({{c1::слово}})": "Frase cloze ({{c1::palabra}})",
  "Чтение / транскрипция": "Lectura / transcripción",
  "Источник (название текста)": "Fuente (título del texto)",
  "Аудио (TTS)": "Audio (TTS)",
  "Настройки AnkiConnect": "Ajustes de AnkiConnect",
  "URL сервера": "URL del servidor",
  "Подключить": "Conectar",
  "Как подключить Anki": "Cómo conectar Anki",
  "Откройте Anki на компьютере. Инструменты → Дополнения → Получить дополнения → код": "Abre Anki en tu ordenador. Herramientas → Complementos → Obtener complementos → código",
  "(AnkiConnect) → перезапустите Anki.": "(AnkiConnect) → reinicia Anki.",
  "Инструменты → Дополнения → AnkiConnect →": "Herramientas → Complementos → AnkiConnect →",
  "Настройки": "Ajustes",
  ". Найдите строку": ". Busca la línea",
  "и замените её на эту (без неё Anki не пускает сайт — поэтому кнопки «ничего не делали»):": "y sustitúyela por esta (sin ella Anki bloquea la web — por eso los botones «no hacían nada»):",
  "Строка скопирована — вставьте её в настройки AnkiConnect": "Línea copiada — pégala en los ajustes de AnkiConnect",
  "Копировать": "Copiar",
  "Нажмите OK, перезапустите Anki и нажмите «Подключить». Если браузер спросит про доступ к локальной сети — разрешите.": "Pulsa OK, reinicia Anki y pulsa «Conectar». Si el navegador pregunta por la red local — permítelo.",
  "Колода": "Mazo",
  "— выберите колоду —": "— elige un mazo —",
  "Колода для каждого языка": "Mazo para cada idioma",
  "Слова на этом языке уйдут в свою колоду. Можно выбрать существующую или вписать новое имя — Anki создаст её сам. Пусто — общая колода выше.": "Las palabras de este idioma van a su propio mazo. Elige uno o escribe un nombre nuevo — Anki lo crea. Vacío — el mazo común de arriba.",
  "Тип карточки (модель)": "Tipo de tarjeta (modelo)",
  "— выберите модель —": "— elige un modelo —",
  "Соответствие полей": "Correspondencia de campos",
  "Введите шаблон для каждого поля. Доступные переменные:": "Escribe una plantilla para cada campo. Variables disponibles:",
  "Поле Anki": "Campo de Anki",
  "Шаблон": "Plantilla",
  "Теги (через пробел)": "Etiquetas (separadas por espacios)",
  "≈ {0}× ревью vs дефолт (0.90)": "≈ {0}× repasos frente al valor por defecto (0.90)",
  "≈ {0}× реже vs дефолт (0.90)": "≈ {0}× menos a menudo frente al valor por defecto (0.90)",
  "Настройки повторения": "Ajustes de repaso",
  "Желаемое удержание (Retention)": "Retención deseada",
  "70% — меньше повторений": "70% — menos repasos",
  "97% — крепче память": "97% — memoria más sólida",
  "Выше значение = лучше память, но": "Más alto = mejor memoria, pero",
  "больше ежедневных повторений": "más repasos diarios",
  ". Рекомендуем 90% (дефолт FSRS).": ". Recomendamos 90% (por defecto en FSRS).",
  "Что это значит на практике": "Qué significa en la práctica",
  "была через 7д →": "era en 7d →",
  "д": "d",
  "была через 30д →": "era en 30d →",
  "была через 180д →": "era en 180d →",
  "Stability карты при удачном «Знаю» × (1.0..3.4) — растёт быстрее при низком retention. 90% — компромисс между «помнить надёжно» и «не утонуть в повторениях».": "La estabilidad de la tarjeta tras un «Sé» × (1.0..3.4) — crece más rápido con retención baja. 90% es un equilibrio entre «recordar bien» y «no ahogarse en repasos».",
  "Начало нового дня": "Inicio de un nuevo día",
  "часов утра": "de la mañana",
  "Карточки со сроком до этого часа считаются сегодняшними. Если занимаетесь поздно ночью — поставьте 4 (как в Anki) или 6.": "Las tarjetas que vencen antes de esta hora cuentan como «de hoy». Si estudias tarde por la noche — pon 4 (como en Anki) o 6.",
  "Дневные лимиты": "Límites diarios",
  "Новые карты": "Tarjetas nuevas",
  "Повторения": "Repasos",
  "Лимит на сессию повторения. 0 = без лимита.": "Límite por sesión de repaso. 0 = sin límite.",
  "Порядок показа": "Orden de presentación",
  "Новые:": "Nuevas:",
  "Сначала карточки, которые вы сейчас учите, потом повторения — самые просроченные первыми. Новые берутся по порядку проектов (его можно поменять перетаскиванием: панель «Повторение» → «Порядок»), внутри проекта — по месту в аудио.": "Primero las tarjetas que estás aprendiendo, luego los repasos — los más atrasados primero. Las nuevas siguen el orden de proyectos (arrastra para cambiarlo: «Repaso» → «Orden»), dentro del proyecto — según su posición en el audio.",
  "↺ Сбросить": "↺ Restablecer",
  "{0}ч {1}м": "{0}h {1}m",
  "{0}м": "{0}m",
  "Дневная цель": "Meta diaria",
  "Карточек в день": "Tarjetas por día",
  "Изменить": "Cambiar",
  "Цель достигнута": "Meta cumplida",
  "слушали": "escuchado",
  "читали": "leído",
  "Ещё карточки": "Más tarjetas",
  "Начать повторение": "Empezar repaso",
  "Порядок проектов": "Orden de proyectos",
  "Колоды на сегодня": "Mazos de hoy",
  "Порядок, в котором берутся новые карточки": "Orden en que se toman las tarjetas nuevas",
  "Порядок": "Orden",
  "Выбранные:": "Seleccionados:",
  "Новые карточки берутся сверху вниз. Перетащите проект за ручку слева.": "Las tarjetas nuevas se toman de arriba abajo. Arrastra un proyecto por el asa de la izquierda.",
  "Перетащить": "Arrastrar",
  "Выше": "Subir",
  "Ниже": "Bajar",
  "Проект": "Proyecto",
  "Учу": "Aprendiendo",
  "Повтор": "Repaso",
  "Выбрать «{0}»": "Seleccionar «{0}»",
  "Выбрать несколько колод": "Seleccionar varios mazos",
  "{0} из {1} карточек пройдено": "{0} de {1} tarjetas hechas",
  "Всего на сегодня:": "Total para hoy:",
  "Все слова · {0}": "Todas las palabras · {0}",
  "Все слова (Тексты)": "Todas las palabras (Textos)",
  "Повторить словарь": "Repasar vocabulario",
  "Нет слов для повторения": "No hay palabras para repasar",
  "Помечайте слова уровнями 1–3 в читалке — они появятся здесь.": "Marca palabras con niveles 1–3 en el lector — aparecerán aquí.",
  "Готово!": "¡Listo!",
  "правильно (": "correctas (",
  "Уровень": "Nivel",
  "✗ Не знаю": "✗ No sé",
  "✓ Знаю!": "✓ ¡Lo sé!",
  "Нет карточек с переводом — сначала добавьте перевод": "No hay tarjetas con traducción — añade primero una traducción",
  "Переместить в папку": "Mover a carpeta",
  "Без папки": "Sin carpeta",
  "отправляю в Anki…": "enviando a Anki…",
  "в Anki: {0} добавлено{1}": "a Anki: {0} añadidas{1}",
  ", {0} уже было": ", {0} ya estaban",
  "Anki не открыт или нет AnkiConnect": "Anki no está abierto o falta AnkiConnect",
  "Нет текста в проекте.": "El proyecto no tiene texto.",
  "Нет слов для повторения.\nПомечайте слова уровнями 1–3 в читалке.": "No hay palabras para repasar.\nMarca palabras con niveles 1–3 en el lector.",
  "Слушать": "Escuchar",
  "Квиз по карточкам": "Quiz de tarjetas",
  "Открыть текст": "Abrir texto",
  "Переименовать": "Renombrar",
  "Удалить офлайн-копию": "Eliminar copia sin conexión",
  "Аудио останется в облаке": "El audio se queda en la nube",
  "Скачать для офлайна": "Descargar sin conexión",
  "Слушать без интернета": "Escuchar sin internet",
  "Отправить в Anki": "Enviar a Anki",
  "Anki должен быть открыт": "Anki debe estar abierto",
  "Скачать для Anki (.txt)": "Descargar para Anki (.txt)",
  "Настройки Anki": "Ajustes de Anki",
  "Читать": "Leer",
  "Квиз по словам": "Quiz de palabras",
  "Слова уровней 1–3 из этого текста": "Palabras de nivel 1–3 de este texto",
  "Привязано к аудио — изменить": "Vinculado a audio — cambiar",
  "Привязать к аудио": "Vincular a audio",
  "Удалить папку": "Eliminar carpeta",
  "Проекты из неё останутся в библиотеке": "Sus proyectos se quedan en la biblioteca",
  "Новое название": "Nuevo nombre",
  "Скачано: работает без интернета": "Descargado: funciona sin internet",
  "Действия": "Acciones",
  "{0} аудио": "{0} audio",
  "пусто": "vacía",
  "остановились на {0}": "parado en {0}",
  "есть текст": "con texto",
  "Не скачалось — повторить": "No se descargó — reintentar",
  "Повторить скачивание": "Reintentar descarga",
  "с аудио": "con audio",
  "Без названия": "Sin título",
  "Текст": "Texto",
  "Привязать «{0}» к аудио": "Vincular «{0}» a audio",
  "Аудиопроектов пока нет.": "Aún no hay proyectos de audio.",
  "Отвязать от аудио": "Desvincular del audio",
  "Сортировка": "Ordenar",
  "Изменённые": "Modificados",
  "А–Я": "A–Z",
  "Скачано {0} из {1}. Не удалось: {2}.": "Descargados {0} de {1}. Fallaron: {2}.",
  "Назад, на главную": "Volver al inicio",
  "Скачать все аудио папки, чтобы слушать без интернета": "Descargar todo el audio de la carpeta para escuchar sin internet",
  "{0} из {1}": "{0} de {1}",
  "Скачать всё": "Descargar todo",
  "Добавить": "Añadir",
  "Папка пуста": "La carpeta está vacía",
  "Добавьте аудио или текст — или перетащите их сюда с главной.": "Añade audio o un texto — o arrástralos aquí desde el inicio.",
  "Аудио проект": "Proyecto de audio",
  "Синхронизация не удалась": "La sincronización falló",
  ". Изменения сохранены на устройстве и отправятся сами, когда появится связь.": ". Los cambios están guardados en el dispositivo y se enviarán solos cuando haya conexión.",
  "Закрыть объявление": "Cerrar anuncio",
  "Название папки": "Nombre de la carpeta",
  "Создать": "Crear",
  "Ничего не найдено": "No se encontró nada",
  "Найдено: {0}": "Encontrado: {0}",
  "200+ карточек": "200+ tarjetas",
  "Нет карточек со словом «": "No hay tarjetas con la palabra «",
  "Повторить сегодня": "Repasar hoy",
  "Начать": "Empezar",
  "На сегодня всё": "Todo listo por hoy",
  "Цель: {0} в день. Изменить — в разделе «Повторение».": "Meta: {0} al día. Cámbiala en «Repaso».",
  "Позанимайтесь сегодня, чтобы не потерять серию": "Estudia hoy para no perder la racha",
  "Стрик": "Racha",
  "позанимайтесь сегодня": "estudia hoy",
  "рекорд {0}": "récord {0}",
  "Играть здесь": "Reproducir aquí",
  "Продолжить:": "Continuar:",
  " · остановились на {0}": " · parado en {0}",
  "Библиотека": "Biblioteca",
  "Добро пожаловать!": "¡Bienvenido!",
  "Загрузите аудио и добавляйте карточки прямо во время прослушивания — или начните с текста.": "Sube audio y añade tarjetas mientras escuchas — o empieza con un texto.",
  "Новый проект": "Nuevo proyecto",
  "Выберите аудиофайл для этого проекта.": "Elige un archivo de audio para este proyecto.",
  "Выберите аудиофайл — он загрузится в облако и будет доступен офлайн.": "Elige un archivo de audio — se sube a la nube y queda disponible sin conexión.",
  "Сжимаем аудио…": "Comprimiendo audio…",
  "WAV → Opus · в 5–10 раз меньше": "WAV → Opus · de 5 a 10 veces más pequeño",
  "Загружаем в облако…": "Subiendo a la nube…",
  "Для длинных файлов — минута-две": "Los archivos largos tardan uno o dos minutos",
  "Нажмите или перетащите файл": "Haz clic o arrastra un archivo",
  "Импорт текста": "Importar texto",
  "Вставьте слова и переводы. Можно начать строку с таймкода": "Pega palabras y traducciones. Opcional: empieza la línea con una marca de tiempo",
  "чтобы задать время карточки.": "para fijar el tiempo de la tarjeta.",
  "apple\tяблоко\n0:30\tcat\tкот\n1:15\tdog\tсобака": "apple\tmanzana\n0:30\tcat\tgato\n1:15\tdog\tperro",
  "Разделитель (между словом и переводом)": "Separador (entre palabra y traducción)",
  "Запятая (,)": "Coma (,)",
  "Другой": "Otro",
  "Введите разделитель": "Escribe un separador",
  "Предпросмотр —": "Vista previa —",
  "Вставьте текст выше": "Pega el texto arriba",
  "...и ещё": "...y",
  "Импортировать": "Importar",
  "нет интернета": "sin internet",
  "сервер не ответил за 15 секунд": "el servidor no respondió en 15 segundos",
  "вход устарел — выйдите и войдите снова": "la sesión caducó — sal y vuelve a entrar",
  "нет связи с сервером": "sin conexión con el servidor",
  "Перемотать к этому моменту": "Ir a este momento",
  "перевод ▾": "traducción ▾",
  "Остановить цикл": "Parar bucle",
  "Зациклить эту карточку": "Repetir esta tarjeta",
  "Не удалось найти субтитры в файле.": "No se encontraron subtítulos en el archivo.",
  "Импортировано {0}. Пропущено {1} (за пределами аудио).": "Importadas {0}. Omitidas {1} (fuera del audio).",
  "Импортировано {0}!": "¡Importadas {0}!",
  "SRS повторение проекта": "Repaso SRS del proyecto",
  "Вдумчивый режим включён — слушание идёт в зачёт уровня": "Modo atento activado — la escucha cuenta para tu nivel",
  "Включить вдумчивый режим: активное прослушивание считается отдельно и продвигает уровень": "Activar modo atento: la escucha activa se cuenta aparte y sube tu nivel",
  "Сейчас играет": "Reproduciendo",
  "Загружено": "Cargado",
  "−{0}с": "−{0}s",
  "Загружается…": "Cargando…",
  "Пауза (пробел)": "Pausa (espacio)",
  "Играть (пробел)": "Reproducir (espacio)",
  "+{0}с": "+{0}s",
  "Снять повтор (C)": "Quitar repetición (C)",
  "Зациклить последние {0} с (клавиша C)": "Repetir los últimos {0} s (tecla C)",
  "Держите, чтобы слушать на {0}× (клавиша S)": "Mantén para escuchar a {0}× (tecla S)",
  "Держать: {0}×": "Mantener: {0}×",
  "+ карточку на": "+ tarjeta en",
  "Настройки воспроизведения": "Ajustes de reproducción",
  "Перемотка:": "Salto:",
  "Цикл": "Bucle",
  "Скорость:": "Velocidad:",
  "Задержка:": "Retraso:",
  "Поставить A": "Marcar A",
  "Поставить B": "Marcar B",
  "Клип: последние": "Clip: últimos",
  "Замедление:": "Ralentizar:",
  "Клавиши:": "Teclas:",
  "— зациклить последние секунды (ещё раз — снять),": "— repetir los últimos segundos (otra vez — quitar),",
  "(держать) — слушать медленно. Вместе: услышали непонятное место → C → держите S.": "(mantener) — escuchar despacio. Juntos: oíste algo confuso → C → mantén S.",
  "Офлайн-копия": "Copia sin conexión",
  "✓ Скачано": "✓ Descargado",
  "Загрузка {0}%...": "Descargando {0}%...",
  "⚠ Ошибка": "⚠ Error",
  "Не скачано": "No descargado",
  "Удалить офлайн-копию? Проект останется в списке.": "¿Eliminar la copia sin conexión? El proyecto sigue en la lista.",
  "Удалить загрузку": "Eliminar descarga",
  "⟳ Повторить": "⟳ Reintentar",
  "Скачать офлайн": "Descargar sin conexión",
  "Текст · {0}": "Texto · {0}",
  "Текст пустой — откройте его в читалке и добавьте.": "El texto está vacío — ábrelo en el lector y añádelo.",
  "Читалка: перевод слов по нажатию, карточки, озвучка": "Lector: traducción al tocar, tarjetas, lectura en voz alta",
  "Открыть в читалке": "Abrir en el lector",
  "Отвязать текст от этого аудио? Сам текст останется в библиотеке.": "¿Desvincular el texto de este audio? El texto se queda en la biblioteca.",
  "Отвязать": "Desvincular",
  "Вставьте текст этого аудио: расшифровку, статью, субтитры…": "Pega el texto de este audio: transcripción, artículo, subtítulos…",
  "Сохраняю…": "Guardando…",
  "Сохранить текст": "Guardar texto",
  "или привязать готовый текст:": "o vincula un texto existente:",
  "Вернуть на место": "Devolver a su sitio",
  "↩ на место": "↩ a su sitio",
  "Зациклить карточку": "Repetir tarjeta",
  "Закрепить карточку": "Fijar tarjeta",
  "нажмите → перевод": "toca → traducción",
  "Карточки": "Tarjetas",
  "Автоскролл вкл": "Desplazamiento automático",
  "Перейти к текущей": "Ir a la actual",
  "Выбрать все": "Seleccionar todo",
  "Зациклить выбранные": "Repetir seleccionadas",
  "Удалить {0}?": "¿Eliminar {0}?",
  "Удалить{0}": "Eliminar{0}",
  "Отмена выбора": "Cancelar selección",
  "Отменить (Ctrl+Z)": "Deshacer (Ctrl+Z)",
  "Выбрать несколько": "Seleccionar varias",
  "Импорт SRT/VTT": "Importar SRT/VTT",
  "ПКМ на таймлайне или кнопка выше": "Clic derecho en la línea de tiempo o el botón de arriba",
  "Новая карточка": "Nueva tarjeta",
  "Текущий ·": "Actual ·",
  "Слово или фраза": "Palabra o frase",
  "напр. résoudre": "p. ej. résoudre",
  "Снять все": "Quitar todas",
  "нажмите для перевода": "toca para traducir",
  "{0}ч": "{0}h",
  "＋ Добавить": "＋ Añadir",
  "− Вычесть": "− Restar",
  "минут": "minutos",
  "слов": "palabras",
  "мин": "min",
  "Сегодня": "Hoy",
  "Всё время": "Siempre",
  "Статистика": "Estadísticas",
  "Все языки": "Todos los idiomas",
  "Пока нет данных — начните читать или слушать": "Aún no hay datos — empieza a leer o escuchar",
  "Слушание": "Escucha",
  "Уровень {0}": "Nivel {0}",
  "Старт": "Inicio",
  " · до ": " · hasta ",
  "ч": "h",
  "Скорректировать вручную (например, добавить часы прослушивания вне приложения)": "Ajustar a mano (por ejemplo, añadir horas de escucha fuera de la app)",
  "/ {0}ч": "/ {0}h",
  "Вдумчиво:": "Atento:",
  "+ Фоном:": "+ De fondo:",
  "Чтение": "Lectura",
  "Скорректировать вручную": "Ajustar a mano",
  "Прослушано": "Escuchado",
  "вдумчиво:": "atento:",
  "Прочитано слов": "Palabras leídas",
  "время:": "tiempo:",
  "По языкам": "Por idioma",
  "Без языка": "Sin idioma",
  "Старые записи, у которых не было языка:": "Registros antiguos sin idioma:",
  " · чтение {0}": " · lectura {0}",
  "За период": "Por periodo",
  "Период": "Periodo",
  "Слов прочитано": "Palabras leídas",
  "Знакомых слов": "Palabras conocidas",
  "Лучший стрик:": "Mejor racha:",
  "Опасная зона": "Zona de peligro",
  "Очистить статистику · {0}": "Borrar estadísticas · {0}",
  "Очистить всю статистику (все языки)": "Borrar todas las estadísticas (todos los idiomas)",
  "Проекты, тексты и карточки сохранятся —": "Proyectos, textos y tarjetas se conservan —",
  "удалятся только цифры": "solo se borran las cifras",
  "этого языка": "de este idioma",
  "по всем языкам": "de todos los idiomas",
  "Прослушано · сегодня": "Escuchado · hoy",
  "Прочитано слов · сегодня": "Palabras leídas · hoy",
  "всех языков": "de todos los idiomas",
  "записей без языка": "de los registros sin idioma",
  "Очистить статистику?": "¿Borrar estadísticas?",
  "Будут удалены все цифры {0}:\n": "Se borrarán todas las cifras {0}:\n",
  "• {0} прослушивания\n": "• {0} de escucha\n",
  "• {0} прочитанных слов\n": "• {0} palabras leídas\n",
  "карточка": "tarjeta",
  "карточки": "tarjetas",
  "карточек": "tarjetas",
  "активный день": "día activo",
  "активных дня": "días activos",
  "активных дней": "días activos",
  "Контент (проекты, тексты, словарь) НЕ удаляется. ": "El contenido (proyectos, textos, vocabulario) NO se borra. ",
  "У вас будет 6 секунд, чтобы отменить действие.": "Tendrás 6 segundos para deshacerlo.",
  "↶ Отменить": "↶ Deshacer",
  "Сохранено": "Guardado",
  "Введите текущий пароль": "Escribe tu contraseña actual",
  "Новый пароль — минимум 6 символов": "Nueva contraseña — mínimo 6 caracteres",
  "Новый пароль совпадает со старым": "La nueva contraseña es igual a la anterior",
  "Неверный текущий пароль": "Contraseña actual incorrecta",
  "Не удалось сменить пароль": "No se pudo cambiar la contraseña",
  "Пароль изменён. Другие устройства выйдут из аккаунта в течение часа.": "Contraseña cambiada. Los otros dispositivos saldrán de la cuenta en una hora.",
  "Не удалось отправить письмо": "No se pudo enviar el correo",
  "Письмо отправлено на {0}.": "Correo enviado a {0}.",
  "Выйти на всех других устройствах? Здесь вы останетесь в аккаунте.": "¿Cerrar sesión en todos los demás dispositivos? Aquí seguirás dentro.",
  "Другие устройства выйдут из аккаунта в течение часа.": "Los otros dispositivos saldrán de la cuenta en una hora.",
  "Не удалось. Проверьте интернет.": "No se pudo. Revisa internet.",
  "Выйти на всех устройствах, включая это?": "¿Cerrar sesión en todos los dispositivos, incluido este?",
  "Профиль": "Perfil",
  "Имя": "Nombre",
  "Видно под вашими разборами слов в общей библиотеке. Почту никто не видит.": "Se muestra bajo tus explicaciones en la biblioteca común. Nadie ve tu correo.",
  "Например, Антон": "Por ejemplo, Antón",
  "Учёба": "Estudio",
  "Язык, цель на день, повторение": "Idioma, meta diaria, repaso",
  "Изучаемый язык": "Idioma que aprendes",
  "Главная, повторение и статистика показывают его.": "El inicio, el repaso y las estadísticas lo muestran.",
  " · для этого языка": " · para este idioma",
  "Меньше": "Menos",
  "Больше": "Más",
  "Алгоритм повторения": "Algoritmo de repaso",
  "Сколько помнить, лимиты новых карточек, начало дня": "Cuánto recordar, límites de tarjetas nuevas, inicio del día",
  "Отправка карточек в программу Anki": "Enviar tarjetas a la aplicación Anki",
  "Оформление": "Apariencia",
  "Тема": "Tema",
  "Светлая": "Claro",
  "Тёмная": "Oscuro",
  "Аркада": "Arcade",
  "Тема «Аркада»": "Tema Arcade",
  "Звуки интерфейса": "Sonidos de la interfaz",
  "Щелчки кнопок и ноты ответов. Молчат, пока играет аудио.": "Clics de botones y notas de respuesta. Se callan mientras suena el audio.",
  "Верных ответов подряд": "Respuestas correctas seguidas",
  "Джекпот!": "¡Jackpot!",
  "Рой слов, Тир, Лови, Пары · пиявок: {0}": "Enjambre, Tiro, Atrapa, Parejas · sanguijuelas: {0}",
  "Рой слов, Тир, Лови, Пары": "Enjambre, Tiro, Atrapa, Parejas",
  "Чтобы играть, нужно хотя бы {0} карточки со словом и переводом — сейчас {1}. Слово — не длиннее {2} знаков.": "Para jugar necesitas al menos {0} tarjetas con palabra y traducción; ahora tienes {1}. Palabras de hasta {2} caracteres.",
  "Не то слово!": "¡Palabra equivocada!",
  "База · волна {0}": "Base · oleada {0}",
  "Сбито: {0}": "Derribadas: {0}",
  "Поле игры «Рой слов»": "Campo de juego de Enjambre de palabras",
  "Рой слов": "Enjambre de palabras",
  "На вас ползут слова из ваших карточек — герой сам стреляет в ближайшие.": "Las palabras de tus tarjetas avanzan hacia ti: tu héroe dispara solo a las más cercanas.",
  "Рекорд: {0}": "Récord: {0}",
  "Новый уровень!": "¡Subes de nivel!",
  "Выберите улучшение": "Elige una mejora",
  "ур. {0}": "nv. {0}",
  "Слова задушили!": "¡Las palabras te atraparon!",
  "Новый рекорд!": "¡Nuevo récord!",
  "Волна: {0}": "Oleada: {0}",
  "Принесено: {0}": "Entregadas: {0}",
  "Слова ползут на вас — хватайте нужные и несите на базу. Улучшения каждый уровень. Сколько продержитесь?": "Las palabras avanzan hacia ti: atrapa las correctas y llévalas a la base. Mejoras en cada nivel. ¿Cuánto aguantarás?",
  "Скорострельность": "Cadencia",
  "Стреляете на 20% чаще": "Disparas un 20 % más seguido",
  "Залп": "Ráfaga",
  "+1 снаряд за выстрел": "+1 proyectil por disparo",
  "Пробивание": "Perforación",
  "Снаряд пробивает ещё одно слово": "Los proyectiles atraviesan una palabra más",
  "Урон": "Daño",
  "Снаряды бьют на 1 сильнее": "Los proyectiles golpean 1 más fuerte",
  "Двигаетесь на 15% быстрее": "Te mueves un 15 % más rápido",
  "Магнит": "Imán",
  "≈ {0} {1}": "≈ {0} {1}",
  "минута": "minuto",
  "минуты": "minutos",
  "Стрик {0} {1}": "Racha de {0} {1}",
  "Бонусный опыт": "XP extra",
  "Твой ход, {0}.": "Tu turno, {0}.",
  "Твой ход.": "Tu turno.",
  "{0} каждый день. По одной хорошей руке.": "{0} cada día. Una buena mano a la vez.",
  "Каждый день. По одной хорошей руке.": "Cada día. Una buena mano a la vez.",
  "Маленькая сессия.": "Una sesión pequeña.",
  "Большой прогресс.": "Un gran progreso.",
  "Твоя колода на сегодня уже на столе.": "Tu baraja de hoy ya está sobre la mesa.",
  "Сыграй {0} {1} и закрой план.": "Juega {0} {1} y cierra el plan.",
  "карточку": "tarjeta",
  "На сегодня всё сыграно. Новые карточки появятся завтра.": "Hoy ya está todo jugado. Mañana habrá tarjetas nuevas.",
  "{0} знакомых + {1} новых": "{0} conocidas + {1} nuevas",
  "Остановились на {0}": "Te quedaste en {0}",
  "Немного удачи между занятиями.": "Un poco de suerte entre clases.",
  "Главная ставка — твои знания.": "Tu conocimiento es la verdadera apuesta.",
  "Учись. Повторяй. Собирай свою колоду.": "Aprende. Repasa. Arma tu baraja.",
  "Каждая карточка — в твою пользу.": "Cada tarjeta juega a tu favor.",
  "Тема «{0}» — для Pro": "El tema «{0}» es para Pro",
  "Только в Pro": "Solo en Pro",
  "Тема «Колода»": "Tema «Baraja»",
  "Вас добило слово": "La palabra que te venció",
  "Почти!": "¡Casi!",
  "Слоты": "Tragamonedas",
  "Крутится…": "Girando…",
  "Крутите — выпадет слово": "Gira y saldrá una palabra",
  "Крутить": "Girar",
  "Внизу база с тремя переводами — набор. Перед каждым набором игра покажет слова: запомните их.": "Abajo está la base con tres traducciones: un juego. Antes de cada juego verás las palabras: recuérdalas.",
  "Нажмите на нужное слово рядом с героем — он его схватит.": "Toca la palabra correcta cerca del héroe para atraparla.",
  "Сбитые слова роняют опыт, а каждое принесённое слово даёт ещё больше. Весь набор принесён — новый уровень и улучшение.": "Las palabras derribadas sueltan experiencia y cada palabra entregada da aún más. Entrega el juego completo: nuevo nivel y mejora.",
  "Запомните слова": "Recuerda las palabras",
  "Набор {0}: запомните слова": "Juego {0}: recuerda las palabras",
  "Найдите их в рое и принесите на базу.": "Encuéntralas en el enjambre y llévalas a la base.",
  "Вперёд!": "¡Adelante!",
  "Или коснитесь перевода на базе — он станет целью, и герой схватит нужное слово, просто наехав на него. Наехали на не то — ранит.": "O toca una traducción en la base: será el objetivo, y el héroe atrapará la palabra correcta con solo chocar con ella. Si chocas con otra, te hiere.",
  "Ведите пальцем по полю — герой идёт следом. Касание перевода на базе — цель, касание слова — схватить, слова в руках — бросить.": "Desliza el dedo y el héroe te sigue. Toca una traducción de la base para elegir objetivo, una palabra para atraparla y la que llevas para soltarla.",
  "WASD или стрелки — идти, щелчок по слову — схватить, по переводу на базе — цель, пробел — бросить, P или Esc — пауза.": "WASD o flechas para moverte, clic en una palabra para atraparla, en una traducción de la base para elegir objetivo, espacio para soltar, P o Esc para pausar.",
  "Руки заняты: несите на базу или бросьте слово": "Manos llenas: llévala a la base o suelta la palabra",
  "Волна {0}!": "¡Oleada {0}!",
  "Блок!": "¡Bloqueo!",
  "Отнесите слово на базу. Не то слово отскочит и ранит — взяли не то, бросьте его.": "Lleva la palabra a la base. La equivocada rebota y te hiere: si tomaste otra, suéltala.",
  "Сбитое слово лежит {0} секунды — его тоже можно схватить.": "Una palabra derribada queda en el suelo {0} segundos: también puedes atraparla.",
  "Крит": "Crítico",
  "Шанс 12% ударить втрое сильнее": "12 % de probabilidad de golpear el triple de fuerte",
  "Молния": "Rayo",
  "Бьёт ближайшее слово и перескакивает на соседние": "Golpea la palabra más cercana y salta a las vecinas",
  "Взрыв": "Explosión",
  "Сбитое слово взрывается и задевает соседей": "La palabra derribada explota y alcanza a las vecinas",
  "Жгучая аура": "Aura ardiente",
  "Обжигает слова вокруг вас": "Quema las palabras a tu alrededor",
  "Щит": "Escudo",
  "Гасит один удар и восстанавливается за несколько секунд": "Absorbe un golpe y se recarga en unos segundos",
  "Регенерация": "Regeneración",
  "Здоровье понемногу восстанавливается": "La salud se recupera poco a poco",
  "Опыт притягивается на 40% дальше": "La experiencia se atrae desde un 40 % más lejos",
  "Длинные руки": "Brazos largos",
  "Хватаете слова на 30% дальше": "Atrapas palabras un 30 % más lejos",
  "Длинные слова и фразы приходят с {0}-й волны: медленные, но крепкие.": "Las palabras largas y frases llegan desde la oleada {0}: lentas pero resistentes.",
  "Броня": "Armadura",
  "+25 к здоровью и столько же лечения": "+25 de salud máxima y la misma curación",
  "Аптечка": "Botiquín",
  "Восстановить половину здоровья": "Recupera la mitad de la salud",
  "Орбита": "Órbita",
  "Вокруг вас кружит ещё одна фишка": "Una ficha más gira a tu alrededor",
  "Холод": "Escarcha",
  "Слова рядом с вами замедляются": "Las palabras cerca de ti se ralentizan",
  "Ударная волна": "Onda de choque",
  "Раз в несколько секунд отбрасывает слова": "Cada pocos segundos empuja las palabras",
  "Рюкзак": "Mochila",
  "Нести на одно слово больше": "Lleva una palabra más",
  "Нажмите слово, которое значит:": "Toca la palabra que significa:",
  "Поймайте слово, которое значит:": "Atrapa la palabra que significa:",
  "Корзина": "Cesta",
  "Водите пальцем или мышью по полю, на компьютере — стрелки ← →": "Mueve el dedo o el ratón por el campo; en el ordenador, las flechas ← →",
  "Жизни: {0}": "Vidas: {0}",
  "Осталось: {0}": "Quedan: {0}",
  "Игры для запоминания": "Juegos para memorizar",
  "Тир, Лови, Пары · пиявок: {0}": "Tiro, Atrapa, Parejas · sanguijuelas: {0}",
  "Тир, Лови, Пары": "Tiro, Atrapa, Parejas",
  "Пиявки": "Sanguijuelas",
  "Накопилось пиявок: {0}": "Sanguijuelas acumuladas: {0}",
  "Карточки, которые вы часто забываете. Закрепите их в играх.": "Tarjetas que olvidas a menudo. Afiánzalas con juegos.",
  "Закрепить": "Afianzar",
  "Пиявки сняты!": "¡Sanguijuelas eliminadas!",
  "Игры": "Juegos",
  "К играм": "A los juegos",
  "Заново": "Reiniciar",
  "Закрепляйте слова в коротких играх. Расписание повторения не меняется.": "Afianza palabras con juegos cortos. Tu calendario de repaso no cambia.",
  "Верно: {0} из {1}": "Correctas: {0} de {1}",
  "Время: {0}": "Tiempo: {0}",
  "Снято пиявок: {0}": "Sanguijuelas eliminadas: {0}",
  "Пиявки — карточки, которые вы забыли {0} раза и больше. {1} верных ответа в играх — и пиявка снята.": "Las sanguijuelas son tarjetas que olvidaste {0} veces o más. {1} aciertos en los juegos la eliminan.",
  "Пиявок нет — все трудные карточки закреплены.": "No hay sanguijuelas: todas las tarjetas difíciles están afianzadas.",
  "Нужно хотя бы 4 карточки со словом и переводом.": "Necesitas al menos 4 tarjetas con palabra y traducción.",
  "Каждый раз — {0} случайных карточек изучаемого языка.": "Cada partida usa {0} tarjetas al azar del idioma que aprendes.",
  "Найдите пары: слово и его перевод": "Encuentra las parejas: palabra y traducción",
  "Стреляйте в слово, которое значит:": "Dispara a la palabra que significa:",
  "Тир": "Tiro",
  "Лови": "Atrapa",
  "Пары": "Parejas",
  "Слова летают — стреляйте в то, что значит перевод сверху.": "Las palabras vuelan: dispara a la que significa la traducción de arriba.",
  "Ловите корзиной верное слово, от остальных уворачивайтесь.": "Atrapa la palabra correcta con la cesta y esquiva las demás.",
  "Найдите пары: слово и его перевод — на время.": "Empareja cada palabra con su traducción, contrarreloj.",
  "ИИ-помощник": "Asistente de IA",
  "Свои ключи для разборов слов — по желанию": "Tus propias claves para explicaciones — opcional",
  "Ключ OpenRouter": "Clave de OpenRouter",
  "Без ключа ИИ-объяснения работают через общий лимит сайта. Свой ключ — бесплатно на": "Sin clave, las explicaciones de IA usan el límite común de la web. Tu propia clave — gratis en",
  ". Хранится только на этом устройстве.": ". Se guarda solo en este dispositivo.",
  "Безопасность": "Seguridad",
  "Пароль и устройства": "Contraseña y dispositivos",
  "Сменить пароль": "Cambiar contraseña",
  "Текущий пароль": "Contraseña actual",
  "Новый пароль (от 6 символов)": "Nueva contraseña (6+ caracteres)",
  "Новый пароль": "Nueva contraseña",
  "Забыли? Письмо для сброса": "¿La olvidaste? Correo para restablecer",
  "Устройства": "Dispositivos",
  "Выйти на других устройствах": "Cerrar sesión en otros dispositivos",
  "Выйти везде": "Cerrar sesión en todas partes",
  "Выйти из аккаунта": "Cerrar sesión",
  "Условия": "Condiciones",
  "Конфиденциальность": "Privacidad",
  "Авторские права": "Derechos de autor",
  "Версия": "Versión",
  "Повторение": "Repaso",
  "{0} на сегодня": "{0} para hoy",
  "На сегодня всё повторено": "Todo repasado por hoy",
  "Здесь появятся карточки из ваших аудиопроектов": "Aquí aparecerán las tarjetas de tus proyectos de audio",
  "Все карточки": "Todas las tarjetas",
  " · с видео": " · con vídeo",
  "Тексты и книги для чтения": "Textos y libros para leer",
  "Книга из файла": "Libro desde archivo",
  "Новый текст": "Nuevo texto",
  "Страница": "Página",
  "Все тексты": "Todos los textos",
  "Начните с первого текста": "Empieza con tu primer texto",
  "Вставьте статью или главу, загрузите книгу EPUB/TXT или привяжите видео с YouTube.": "Pega un artículo o un capítulo, sube un libro EPUB/TXT o vincula un vídeo de YouTube.",
  "Главная": "Inicio",
  "Ошибка загрузки: ": "Error al subir: ",
  "Недостаточно места на диске.{0}{1} Освободите место и попробуйте снова.": "No hay espacio suficiente.{0}{1} Libera espacio e inténtalo de nuevo.",
  " Файл: ~{0} МБ.": " Archivo: ~{0} MB.",
  " Свободно: ~{0} МБ.": " Libre: ~{0} MB.",
  "Возможно, мало места: ~{0} МБ свободно, нужно ~{1} МБ для {2} файлов. Продолжить?": "Puede faltar espacio: ~{0} MB libres, se necesitan ~{1} MB para {2} archivos. ¿Continuar?",
  "Аудио «{0}» удалён": "Audio «{0}» eliminado",
  "Папка «{0}» удалена": "Carpeta «{0}» eliminada",
  "шаг 1 (audio): {0}": "paso 1 (audio): {0}",
  "не отправлено изменений: {0}{1} — повторю сам": "cambios sin enviar: {0}{1} — lo reintentaré",
  "Текст «{0}» удалён": "Texto «{0}» eliminado",
  "Вся статистика очищена": "Todas las estadísticas borradas",
  "Записи без языка очищены": "Registros sin idioma borrados",
  "Статистика «{0}» очищена": "Estadísticas «{0}» borradas",
  "Загрузка…": "Cargando…",
  "Поиск по карточкам": "Buscar tarjetas",
  "Синхронизация…": "Sincronizando…",
  "Синхронизировать сейчас": "Sincronizar ahora",
  "Не удалось: {0}": "Falló: {0}",
  "нет связи": "sin conexión",
  "В очереди: {0}": "En cola: {0}",
  "Аккаунт и настройки": "Cuenta y ajustes",
  "Карточки поверх окон": "Tarjetas sobre otras ventanas",
  "Alt+Q — показать или скрыть": "Alt+Q — mostrar u ocultar",
  "Нажмите Alt+Q — карточки появятся поверх всех окон.": "Pulsa Alt+Q — las tarjetas aparecerán sobre todas las ventanas.",
  "Выйти": "Cerrar sesión",
  "Создать в «{0}»": "Crear en «{0}»",
  "Карточки по ходу прослушивания": "Tarjetas mientras escuchas",
  "Статья, глава, субтитры": "Artículo, capítulo, subtítulos",
  "EPUB или TXT": "EPUB o TXT",
  "Папка": "Carpeta",
  "Вышло обновление AntonCards": "Hay una actualización de AntonCards",
  "Обновить": "Actualizar",
  "Загружаю последнюю версию…": "Descargando la última versión…",
  "Не удалось обновить. Попробуйте ещё раз.": "No se pudo actualizar. Inténtalo de nuevo.",
  "Вышла новая версия приложения": "Hay una nueva versión de la app",
  "Скачать": "Descargar",
  "Разделы": "Secciones",
  "Новый": "Nuevo",
  "русский": "ruso",
  "английский": "inglés",
  "украинский": "ucraniano",
  "немецкий": "alemán",
  "французский": "francés",
  "испанский": "español",
  "итальянский": "italiano",
  "португальский": "portugués",
  "польский": "polaco",
  "турецкий": "turco",
  "японский": "japonés",
  "китайский": "chino",
  "корейский": "coreano",
  "общий словарь": "diccionario común",
  "ИИ-словарь": "diccionario de IA",
  "Язык перевода": "Idioma de traducción",
  "{0}   (Tab — вставить)": "{0}   (Tab — insertar)",
  "напр. решать": "p. ej. resolver",
  "Добавлять чтение каной перед переводом": "Añadir la lectura en kana antes de la traducción",
  "кана:": "kana:",
  "Ищу перевод…": "Buscando traducción…",
  "Подсказок нет — впишите перевод сами": "Sin sugerencias — escribe la traducción tú mismo",
  "Укажите язык проекта, чтобы появились подсказки перевода.": "Indica el idioma del proyecto para ver sugerencias de traducción.",
  "Очистить поиск": "Borrar búsqueda",
  "Аккаунт": "Cuenta",
  "Низкая": "Baja",
  "Средняя": "Media",
  "Высокая": "Alta",
  "Очень высокая": "Muy alta",
  "Максимальная": "Máxima",
  "На счёте Anthropic закончились деньги. Пополните баланс в console.anthropic.com.": "Tu saldo de Anthropic se agotó. Recárgalo en console.anthropic.com.",
  "Ключ Claude не подходит. Проверьте, что он скопирован целиком.": "La clave de Claude no funciona. Comprueba que se copió entera.",
  "У этого ключа нет доступа к модели.": "Esta clave no tiene acceso al modelo.",
  "Такой модели нет. Выберите другую в настройках.": "Ese modelo no existe. Elige otro en ajustes.",
  "Слишком много запросов. Подождите минуту.": "Demasiadas solicitudes. Espera un minuto.",
  "Claude сейчас перегружен. Попробуйте чуть позже.": "Claude está saturado ahora. Inténtalo un poco más tarde.",
  "Ошибка Claude ({0}): {1}": "Error de Claude ({0}): {1}",
  "нет сети": "sin red",
  "Нет связи с Claude. Проверьте интернет.": "Sin conexión con Claude. Revisa internet.",
  "Claude отказался отвечать на этот запрос.": "Claude se negó a responder a esta solicitud.",
  "Ответ не поместился. Попробуйте меньшую глубину размышлений.": "La respuesta no cupo. Prueba con menos profundidad de razonamiento.",
  "Claude ответил не в том формате. Попробуйте ещё раз.": "Claude respondió en un formato incorrecto. Inténtalo de nuevo.",
  "Смешной факт": "Dato curioso",
  "Грустный факт": "Dato triste",
  "Жуткий факт": "Dato inquietante",
  "Удивительный факт": "Dato sorprendente",
  "Исторический факт": "Dato histórico",
  "Ключ не подошёл": "La clave no funcionó",
  "С ключом Claude в читалке есть подробный разбор слова (происхождение, как запомнить) и перевод всей страницы. Ключ — на console.anthropic.com, оплата за использование.": "Con una clave de Claude el lector da una explicación detallada de la palabra (origen, cómo recordarla) y traduce la página entera. La clave está en console.anthropic.com, pago por uso.",
  "Ключ Claude": "Clave de Claude",
  "Проверяю…": "Comprobando…",
  "Сохранить и проверить": "Guardar y comprobar",
  "✓ Ключ работает": "✓ La clave funciona",
  "Ключ хранится только в этом браузере и уходит только в Anthropic.": "La clave se guarda solo en este navegador y solo va a Anthropic.",
  "Модель для разборов": "Modelo para explicaciones",
  "за 1M токенов": "por 1M de tokens",
  "Глубина размышлений": "Profundidad de razonamiento",
  "Один разбор ≈ $": "Una explicación ≈ $",
  ". Словарь страницы — Claude Haiku 5.5, доли цента. В этом месяце: $": ". Diccionario de página — Claude Haiku 5.5, fracciones de céntimo. Este mes: $",
  "Делиться разборами в общей библиотеке": "Compartir explicaciones en la biblioteca común",
  "Файл больше 25 МБ.": "El archivo pesa más de 25 MB.",
  "Часть {0}": "Parte {0}",
  "в файле не нашлось текста": "no se encontró texto en el archivo",
  "Это не похоже на книгу EPUB. Книги с защитой от копирования (DRM) прочитать нельзя.": "No parece un libro EPUB. Los libros con protección anticopia (DRM) no se pueden leer.",
  "Файл не прочитался: {0}": "No se pudo leer el archivo: {0}",
  "Книга": "Libro",
  "Загружаю {0} из {1}…": "Subiendo {0} de {1}…",
  "Импорт остановился: {0}": "La importación se detuvo: {0}",
  "📚 Книга из файла": "📚 Libro desde archivo",
  "EPUB или TXT до 25 МБ. Книга станет папкой, каждая глава — текстом в ней. Файл читается здесь, в браузере; на сервер уходят только выбранные главы.": "EPUB o TXT de hasta 25 MB. El libro será una carpeta y cada capítulo un texto dentro. El archivo se lee aquí, en el navegador; al servidor solo van los capítulos elegidos.",
  "Читаю файл…": "Leyendo el archivo…",
  "Выбрать файл": "Elegir archivo",
  "Название (папка)": "Título (carpeta)",
  "Язык книги": "Idioma del libro",
  "Найдено глав:": "Capítulos encontrados:",
  ". Снимите галочки с лишнего — обложки и оглавления уже сняты.": ". Desmarca lo que sobre — las portadas e índices ya están desmarcados.",
  "сл.": "pal.",
  "Загрузить {0} гл.": "Subir {0} cap.",
  "Другой файл": "Otro archivo",
  "файл внутри книги слишком большой": "un archivo dentro del libro es demasiado grande",
  "неизвестное сжатие": "compresión desconocida",
  "Что-то сломалось": "Algo se rompió",
  "Произошла ошибка в приложении. Обновите страницу; если ошибка повторится — скопируйте текст ниже и пришлите его нам.": "Algo salió mal en la aplicación. Recarga la página; si vuelve a pasar, copia el texto de abajo y envíanoslo.",
  "Перезагрузить": "Recargar",
  "Попробовать продолжить": "Intentar continuar",
  "Библиотека ещё не создана в Supabase.": "La biblioteca aún no está creada en Supabase.",
  "Нужно один раз выполнить supabase_migration_admin.sql в Supabase (SQL Editor).": "Ejecuta una vez supabase_migration_admin.sql en Supabase (SQL Editor).",
  "Журнала ещё нет: выполните supabase_migration_client_errors.sql в Supabase.": "Aún no hay registro: ejecuta supabase_migration_client_errors.sql en Supabase.",
  "нет ответа сервера за {0} с": "sin respuesta del servidor en {0} s",
  "Не синхронизировано": "Sin sincronizar",
  "Нужна настройка базы": "Hay que configurar la base de datos",
  "Изменения сохранены на устройстве и отправятся сами": "Los cambios están guardados en el dispositivo y se enviarán solos",
  "Синхронизировано": "Sincronizado",
  "AntonCards — главная": "AntonCards — inicio",
  "Синхр.": "Sinc.",
  "Очередь": "Cola",
  "сейчас": "ahora",
  "{0} мин": "{0} min",
  "{0}д": "{0}d",
  "{0}мес": "{0} mes",
  "{0}г": "{0} a",
  "Новая": "Nueva",
  "Сейчас": "Ahora",
  "Через {0}м": "En {0} min",
  "Скоро": "Pronto",
  "Завтра": "Mañana",
  "Через {0}д": "En {0} d",
  "Вперемешку с повторениями": "Mezcladas con los repasos",
  "После повторений": "Después de los repasos",
  "Перед повторениями": "Antes de los repasos",
  "— нет перевода —": "— sin traducción —",
  "Не удалось получить объяснение": "No se pudo obtener la explicación",
  "Добавлено в «{0}»": "Añadido a «{0}»",
  "Уже есть в колоде": "Ya está en el mazo",
  "фразу «{0}»": "la frase «{0}»",
  "слово «{0}»": "la palabra «{0}»",
  "Удалить {0}? Это уберёт перевод, статус и SRS-прогресс.": "¿Eliminar {0}? Se borrarán la traducción, el estado y el progreso SRS.",
  "Узнаю": "Reconozco",
  "Знакомо": "Familiar",
  "Выучено": "Aprendida",
  "Знаю ✓": "La sé ✓",
  "Фраза": "Frase",
  "Прослушать произношение": "Escuchar la pronunciación",
  "Скопировано": "Copiado",
  "Скопировать": "Copiar",
  "Остановить": "Detener",
  "Спросить заново": "Preguntar de nuevo",
  "Объяснение от ИИ (грамматика, контекст)": "Explicación de IA (gramática, contexto)",
  "Подробный разбор: происхождение, история, факт (Claude и общая библиотека)": "Explicación detallada: origen, historia, dato (Claude y la biblioteca común)",
  "✓ Сохранено": "✓ Guardado",
  "Пропущено": "Omitido",
  "Скопировать перевод": "Copiar traducción",
  "скопировано": "copiado",
  "копировать": "copiar",
  "Перевожу…": "Traduciendo…",
  "Свой перевод…": "Tu propia traducción…",
  "ИИ-объяснение": "Explicación de IA",
  "печатает…": "escribiendo…",
  "В заметки": "A notas",
  "Запрашиваю объяснение…": "Pidiendo una explicación…",
  "Заметки": "Notas",
  "Пример, контекст…": "Ejemplo, contexto…",
  "Уровень — нажмите, чтобы сохранить": "Nivel — toca para guardar",
  "Отправляем…": "Enviando…",
  "Добавить в Anki": "Añadir a Anki",
  "Пропустить": "Omitir",
  "Удалить карточку": "Eliminar tarjeta",
  "Удалить фразу": "Eliminar frase",
  "новых": "nuevas",
  "учу": "aprendo",
  "знаю": "sé",
  "Правильно!": "¡Correcto!",
  "Правильный ответ: ": "Respuesta correcta: ",
  "Cloze Quiz — заполни пропуски (": "Cloze Quiz — completa los huecos (",
  "слов)": "palabras)",
  "верно": "bien",
  "Перемотать видео к этому моменту": "Llevar el vídeo a este momento",
  "Продолжить": "Continuar",
  "Убрать из цикла (Shift+click — диапазон)": "Quitar del bucle (Shift+clic — rango)",
  "Зациклить (Shift+click — диапазон)": "Bucle (Shift+clic — rango)",
  "Словарь готов: {0} сл. · ~${1}": "Diccionario listo: {0} pal. · ~${1}",
  "Все слова страницы уже в словаре": "Todas las palabras de la página ya están en el diccionario",
  "Не получилось": "No funcionó",
  "Нажмите, чтобы переименовать": "Haz clic para renombrar",
  "Статистика по языку": "Estadísticas del idioma",
  "Словарь страницы: Claude переведёт все новые слова этой страницы (доли цента), перевод появится у всех в общем словаре": "Diccionario de página: Claude traduce todas las palabras nuevas de esta página (fracciones de céntimo) y la traducción aparece para todos en el diccionario común",
  "Словарь…": "Diccionario…",
  "Словарь": "Diccionario",
  "Остановить чтение": "Dejar de leer",
  "Прочитать страницу вслух (голос и скорость — в меню языка)": "Leer la página en voz alta (voz y velocidad — en el menú de idioma)",
  "Вслух": "En voz alta",
  "Квиз по словам этого текста": "Quiz de palabras de este texto",
  "Нет слов для повторения.\nПомечайте слова уровнями 1–3.": "No hay palabras para repasar.\nMarca palabras con niveles 1–3.",
  "Выйти из режима пропусков": "Salir del modo de huecos",
  "Пропуски: изучаемые слова скрываются, их нужно вспомнить": "Huecos: las palabras que aprendes se ocultan y debes recordarlas",
  "Выйти из режима фразы": "Salir del modo frase",
  "Режим фразы — нажимайте слова по очереди, чтобы собрать фразу": "Modo frase — toca las palabras una a una para formar una frase",
  "Фраза: вкл": "Frase: activado",
  "Скрыть видео": "Ocultar vídeo",
  "Показать YouTube-видео": "Mostrar el vídeo de YouTube",
  "Прикрепить YouTube-видео к этому тексту": "Vincular un vídeo de YouTube a este texto",
  "Языки и озвучка": "Idiomas y voz",
  "С языка": "Desde",
  "На язык": "A",
  "Скорость речи": "Velocidad de voz",
  "Голос": "Voz",
  "Авто (": "Auto (",
  "Японский: слова делятся по словарю (kuromoji)": "Japonés: las palabras se separan con el diccionario (kuromoji)",
  "Быстрый перевод — MyMemory (бесплатно)": "Traducción rápida — MyMemory (gratis)",
  "Изменить текст": "Editar texto",
  "Добавить текст": "Añadir texto",
  "Словарь загружен ✓": "Diccionario cargado ✓",
  "Ошибка: {0}": "Error: {0}",
  "Индексирую словарь…": "Indexando el diccionario…",
  "Загружаю японский словарь…": "Cargando el diccionario japonés…",
  "Повторить": "Reintentar",
  "Очистить кеш словаря и скачать заново — если предыдущий кеш битый": "Borrar la caché del diccionario y descargarla de nuevo — si la anterior está dañada",
  "Сброс": "Restablecer",
  "Один раз ~17 МБ — потом работает без интернета. Читать можно уже сейчас: пока словарь грузится, слова делятся приблизительно.": "Una sola vez ~17 MB — después funciona sin internet. Puedes leer ya: mientras se carga el diccionario, las palabras se separan de forma aproximada.",
  "Сделать фразу из «{0}»?": "¿Formar una frase con «{0}»?",
  "Нажимайте слова по очереди": "Toca las palabras una a una",
  "Очистить выделение": "Borrar selección",
  "Сохранить фразу (откроется карточка)": "Guardar frase (se abrirá una tarjeta)",
  "✓ Сохранить": "✓ Guardar",
  "ТЯНИ": "ARRASTRA",
  "ТЯНИ К КРАЮ — РЯДОМ С ТЕКСТОМ": "ARRASTRA AL BORDE — JUNTO AL TEXTO",
  "Закрепить сверху": "Fijar arriba",
  "Видео слева, текст справа": "Vídeo a la izquierda, texto a la derecha",
  "Видео справа, текст слева": "Vídeo a la derecha, texto a la izquierda",
  "Открепить — вернуть в обычный режим": "Soltar — volver al modo normal",
  "ВИДЕО": "VÍDEO",
  "СЛЕВА": "IZQUIERDA",
  "СПРАВА": "DERECHA",
  "Перенести на другую сторону": "Mover al otro lado",
  "Плавающее окно": "Ventana flotante",
  "Над текстом": "Encima del texto",
  "Потяните, чтобы изменить ширину": "Arrastra para cambiar el ancho",
  "Потяните, чтобы изменить размер": "Arrastra para cambiar el tamaño",
  "Окно": "Ventana",
  "Плавающее окно — читать и смотреть одновременно": "Ventana flotante — leer y ver a la vez",
  "Открепить": "Soltar",
  "Сверху": "Arriba",
  "Видео снова прокручивается с текстом": "El vídeo vuelve a desplazarse con el texto",
  "Закрепить видео сверху, текст прокручивается под ним": "Fijar el vídeo arriba, el texto se desplaza debajo",
  "◧ Слева": "◧ Izquierda",
  "Видео слева, текст справа (как Snap в Windows)": "Vídeo a la izquierda, texto a la derecha (como Snap en Windows)",
  "Справа ◨": "Derecha ◨",
  "↺ сброс": "↺ restablecer",
  "Отпустите — видео встанет": "Suelta — el vídeo se acoplará",
  "слева": "izquierda",
  "справа": "derecha",
  "сверху": "arriba",
  "Добавьте текст, чтобы начать читать": "Añade un texto para empezar a leer",
  "Все слова сначала": "Todas las palabras empiezan",
  "синие": "azules",
  ". Сохранённые фразы —": ". Las frases guardadas son",
  "фиолетовые": "moradas",
  "Вставить текст": "Pegar texto",
  "Загрузить файл": "Subir archivo",
  "Новое": "Nuevas",
  "Выделено": "Seleccionadas",
  "Стр.": "Pág.",
  "из": "de",
  "Отмечаю…": "Marcando…",
  "Конец": "Fin",
  "Дальше →": "Siguiente →",
  "✓ Прочитано": "✓ Leído",
  "✓ Прочитано, дальше →": "✓ Leído, siguiente →",
  "Все новые слова этой страницы станут «знаю»": "Todas las palabras nuevas de esta página pasarán a «sé»",
  "Новые слова этой страницы станут «знаю», и откроется следующая": "Las palabras nuevas de esta página pasarán a «sé» y se abrirá la siguiente",
  "Перетащить панель (двойной щелчок — вернуть в угол)": "Arrastrar el panel (doble clic — volver a la esquina)",
  "Воспроизвести": "Reproducir",
  "Развернуть панель": "Expandir panel",
  "Текущая позиция / длительность": "Posición actual / duración",
  "Назад на 5 секунд": "Atrás 5 segundos",
  "Назад на 2 секунды": "Atrás 2 segundos",
  "Вперёд на 2 секунды": "Adelante 2 segundos",
  "Вперёд на 5 секунд": "Adelante 5 segundos",
  "Автопауза включена — пауза после каждой строки": "Pausa automática activada — pausa tras cada línea",
  "Включить паузу после каждой строки": "Pausar tras cada línea",
  "Авто": "Auto",
  "Скорость воспроизведения": "Velocidad de reproducción",
  "Снять все циклы": "Quitar todos los bucles",
  "Свернуть панель": "Contraer panel",
  "Вставить": "Pegar",
  "Файл": "Archivo",
  "Вставьте статью, рассказ или расшифровку…": "Pega un artículo, un relato o una transcripción…",
  "Перетащите файл сюда или нажмите, чтобы выбрать": "Suelta un archivo aquí o haz clic para elegir",
  "Подходят: .txt, .md, .srt, .vtt": "Admitidos: .txt, .md, .srt, .vtt",
  "Прикреплено": "Vinculado",
  " · {0} отрезков": " · {0} fragmentos",
  "✕ Открепить видео": "✕ Desvincular vídeo",
  "Вставьте ссылку, чтобы заменить видео…": "Pega una URL para cambiar el vídeo…",
  "Ссылка на YouTube (например, https://youtube.com/watch?v=…)": "Enlace de YouTube (p. ej., https://youtube.com/watch?v=…)",
  "Видео найдено:": "Vídeo encontrado:",
  "Открыть на YouTube": "Abrir en YouTube",
  "Транскрипция необязательна — без неё видео просто прикрепится.": "La transcripción es opcional — sin ella el vídeo solo se vincula.",
  "С транскрипцией будет синхронизация по таймкодам:": "Con transcripción tendrás sincronización por tiempo:",
  "1. На YouTube: «…» → «Показать транскрипцию»": "1. En YouTube: «…» → «Mostrar transcripción»",
  "2. Скопируйте текст и вставьте ниже": "2. Copia el texto y pégalo abajo",
  "Вставьте расшифровку с YouTube (необязательно — для синхронизации)…": "Pega la transcripción de YouTube (opcional — para sincronizar)…",
  "✓ Найдено": "✓ Encontrados",
  "временны́х отрезков — синхронизация будет доступна": "fragmentos de tiempo — habrá sincronización",
  "Заменить видео": "Cambiar vídeo",
  "Прикрепить видео": "Vincular vídeo",
  " (текст не трогаем)": " (el texto no cambia)",
  "Заменить текст транскрипцией": "Sustituir el texto por la transcripción",
  "Загрузить транскрипцию как текст": "Cargar la transcripción como texto",
  "слов ·": "palabras ·",
  "знаков": "caracteres",
  "0 МБ": "0 MB",
  "{0} ГБ": "{0} GB",
  "{0} МБ": "{0} MB",
  "слово": "palabra",
  "слова": "palabras",
  "Anki не отвечает — откройте Anki и проверьте «Настройки AnkiConnect»": "Anki no responde — abre Anki y revisa «Ajustes de AnkiConnect»",
  "Вы": "Tú",
  "Удалить этот разбор?": "¿Eliminar esta explicación?",
  "Разбор слова {0}": "Explicación: {0}",
  "Произнести": "Pronunciar",
  "Ищу разборы в библиотеке…": "Buscando explicaciones en la biblioteca…",
  "Ваш": "Tuya",
  "Здесь, в этом предложении": "Aquí, en esta frase",
  "Происхождение": "Origen",
  "История": "Historia",
  "Факт": "Dato",
  "Родственные слова": "Palabras relacionadas",
  "Как запомнить": "Cómo recordarla",
  "Ваш разбор": "Tu explicación",
  "Автор: {0}": "Autor: {0}",
  " · только на этом устройстве": " · solo en este dispositivo",
  "Убрать лайк": "Quitar me gusta",
  "Нравится": "Me gusta",
  "Виден всем": "Visible para todos",
  "Только мне": "Solo yo",
  "Взять перевод": "Usar la traducción",
  "Разбора этого слова в библиотеке пока нет. Сделайте первый — он появится у всех, кто читает на этом языке.": "Aún no hay explicación de esta palabra en la biblioteca. Haz la primera — la verán todos los que leen en este idioma.",
  "Разбора этого слова пока нет. Подробные разборы делает Claude: добавьте свой ключ в Аккаунт → «Claude: разбор слов». Разборы других учеников видны и без ключа.": "Aún no hay explicación de esta palabra. Las explicaciones detalladas las hace Claude: añade tu clave en Ajustes → Asistente de IA. Las de otros estudiantes se ven sin clave.",
  "Claude разбирает слово…": "Claude está analizando la palabra…",
  "Пожелание (необязательно): «проще», «больше истории»…": "Deseo (opcional): «más sencillo», «más historia»…",
  "Новый разбор": "Nueva explicación",
  "Разобрать с Claude": "Explicar con Claude",
  "Язык интерфейса": "Idioma de la interfaz",
  "Как в системе": "Como el sistema",
  "Сейчас: {0}": "Ahora: {0}",
  "Приложение перезапустится на выбранном языке.": "La app se reiniciará en el idioma elegido.",
  "Завершите вход в открывшемся браузере — потом приложение откроется само.": "Termina de entrar en el navegador que se abrió — luego la app se abrirá sola.",
  "Не удалось завершить вход: {0}": "No se pudo terminar de entrar: {0}",
  "Новый пароль совпадает с прежним — придумайте другой.": "La nueva contraseña es igual a la anterior — elige otra.",
  "Этот пароль слишком простой или уже встречался в утечках — придумайте другой.": "Esta contraseña es demasiado simple o ya apareció en filtraciones — elige otra.",
  "Для смены пароля войдите заново и повторите.": "Para cambiar la contraseña, vuelve a entrar y repite.",
  "Вдумчивый режим": "Modo atento",
  "Вдумчиво": "Atento",
  "Своя нейросеть или ключи — по желанию": "Tu propio modelo o claves — opcional",
  "Вы перешли по ссылке из письма. Придумайте новый пароль для {0}.": "Llegaste por el enlace del correo. Elige una nueva contraseña para {0}.",
  "Пароль сохранён. Входите с ним на всех устройствах.": "Contraseña guardada. Úsala en todos tus dispositivos.",
  "Скрыть пароль": "Ocultar contraseña",
  "Показать пароль": "Mostrar contraseña",
  "Позже": "Más tarde",
  "Сохранить пароль": "Guardar contraseña",
  "ИИ": "IA",
  "Нет такой модели или адреса: {0}": "No existe ese modelo o dirección: {0}",
  "Нет связи с нейросетью ({0}). Проверьте адрес и интернет.": "Sin conexión con la IA ({0}). Revisa la dirección e internet.",
  "Нейросеть ответила не в том формате. Попробуйте ещё раз или другую модель.": "La IA respondió en un formato incorrecto. Inténtalo de nuevo o con otro modelo.",
  "Пустой ответ — проверьте название модели.": "Respuesta vacía — revisa el nombre del modelo.",
  "Укажите адрес и модель": "Indica la dirección y el modelo",
  "Своя нейросеть": "Tu propia IA",
  "Любой сервис с API как у OpenAI: объяснения, разборы слов и словарь страницы пойдут через него. Ключ хранится только на этом устройстве.": "Cualquier servicio con una API como la de OpenAI: explicaciones, análisis de palabras y el diccionario de página irán por él. La clave se guarda solo en este dispositivo.",
  "Сервис": "Servicio",
  "— выберите —": "— elige —",
  "Другой (свой адрес)": "Otro (tu propia dirección)",
  "Адрес API": "Dirección de la API",
  "Ключ": "Clave",
  "где взять": "dónde conseguirla",
  "не нужен": "no hace falta",
  "Модель": "Modelo",
  "✓ Работает — теперь объяснения и разборы идут через {0}": "✓ Funciona — ahora las explicaciones y análisis van por {0}",
  "Разбора этого слова пока нет. Подробные разборы делает ИИ: добавьте ключ Claude или свою нейросеть в Настройки → «ИИ-помощник». Разборы других учеников видны и без ключа.": "Aún no hay explicación de esta palabra. Las explicaciones detalladas las hace la IA: añade una clave de Claude o tu propia IA en Ajustes → Asistente de IA. Las de otros estudiantes se ven sin clave.",
  "{0} разбирает слово…": "{0} está analizando la palabra…",
  "Разобрать с ИИ": "Explicar con IA",
  "Озвучка": "Leer en voz alta",
  "Снова": "Otra vez",
  "Хорошо": "Bien",
  "Легко": "Fácil",
  "1 · 2 · 3 · 4 — оценка, пробел — «Хорошо»": "1 · 2 · 3 · 4 — valorar, espacio — «Bien»",
  "Максимальный интервал": "Intervalo máximo",
  "Карточка не уйдёт дальше этого срока, даже если вы её хорошо помните. 36500 — без ограничения.": "Una tarjeta no se programará más allá de este plazo, aunque la recuerdes bien. 36500 — sin límite.",
  "{0} из {1} строк позже конца этого аудио. Если это часть разрезанного файла — с какого времени она начинается? Например 30:00. Пусто — без сдвига.": "{0} de {1} líneas están después del final de este audio. Si es una parte de un archivo dividido, ¿desde qué tiempo empieza? Por ejemplo 30:00. Vacío — sin desplazamiento.",
  "Шаги заучивания": "Pasos de aprendizaje",
  "После «Снова»": "Después de «Otra vez»",
  "нет": "ninguno",
  "Шаги переучивания": "Pasos de reaprendizaje",
  "Через сколько карточка вернётся, пока вы её учите: m — минуты, h — часы, d — дни, через пробел. «Хорошо» ведёт на следующий шаг, после последнего карточка уходит в повторение. По умолчанию 1m 10m и 10m, как в Anki.": "Cuándo vuelve una tarjeta mientras la aprendes: m — minutos, h — horas, d — días, separados por espacios. «Bien» pasa al siguiente paso; después del último la tarjeta va a repaso. Por defecto 1m 10m y 10m, como en Anki.",
  "EPUB, PDF или TXT": "EPUB, PDF o TXT",
  "PDF больше 80 МБ.": "El PDF pesa más de 80 MB.",
  "Читаю страницу {0} из {1}…": "Leyendo la página {0} de {1}…",
  "PDF не открылся — файл повреждён или это не PDF.": "El PDF no se abrió: el archivo está dañado o no es un PDF.",
  "PDF защищён паролем — снимите защиту и попробуйте снова.": "El PDF está protegido con contraseña: quita la protección e inténtalo de nuevo.",
  "В PDF нет текста — похоже, это скан (картинки страниц). Такие пока не читаются.": "Este PDF no tiene texto: parece un escaneo (imágenes de páginas). Esos aún no se pueden leer.",
  "Не загрузился модуль чтения PDF — проверьте интернет.": "No se cargó el lector de PDF: revisa la conexión.",
  "EPUB, PDF или TXT. Книга станет папкой, каждая глава — текстом в ней. Файл читается здесь, на устройстве; на сервер уходят только выбранные главы.": "EPUB, PDF o TXT. El libro se convierte en una carpeta y cada capítulo en un texto dentro. El archivo se lee aquí, en tu dispositivo; al servidor solo van los capítulos elegidos.",
  "Очередь: {0}": "Cola: {0}",
  "Убрать из очереди": "Quitar de la cola",
  "Сейчас №{0} в очереди": "Ahora n.º {0} en la cola",
  "Играть следующим": "Reproducir a continuación",
  "Сразу после текущего аудио": "Justo después del audio actual",
  "Добавить в очередь": "Añadir a la cola",
  "В конец очереди": "Al final de la cola",
  "в очереди: {0}": "en cola: {0}",
  "Открыть очередь": "Abrir la cola",
  "Далее: {0}": "Siguiente: {0}",
  "Очередь: аудио одно за другим": "Cola: audios uno tras otro",
  "Найти аудио": "Buscar audio",
  "Нет аудио с загруженным звуком.": "No hay audios con sonido subido.",
  "уже в очереди": "ya está en la cola",
  "играет сейчас": "sonando ahora",
  "играет": "sonando",
  "на паузе": "en pausa",
  "Далее": "A continuación",
  "Очередь пуста. Добавьте аудио — они будут играть одно за другим, как выпуски подкаста.": "La cola está vacía. Añade audios: sonarán uno tras otro, como episodios de un pódcast.",
  "Выбрать аудио": "Elegir audios",
  "Играть сейчас": "Reproducir ahora",
  "Убрать из очереди: {0}": "Quitar de la cola: {0}",
  "Играет по порядку, одно за другим": "Suena en orden, uno tras otro",
  "Добавить аудио": "Añadir audio",
  "Добавить: {0}": "Añadir: {0}",
  "Очистить очередь?": "¿Vaciar la cola?",
  "Уровень растёт от вдумчивого слушания. Включите «Вдумчиво» в плеере — и время пойдёт в зачёт.": "El nivel sube con la escucha atenta. Activa «Atento» en el reproductor y el tiempo contará.",
  "Аудио для проекта": "Audio del proyecto",
  "Новое аудио": "Nuevo audio",
  "показать полностью ▾": "mostrar todo ▾",
  "Скопировать текст ошибки": "Copiar el texto del error",
  "Громкость {0}% — колёсико мыши меняет": "Volumen {0} % — la rueda del ratón lo cambia",
  "Включить звук": "Activar el sonido",
  "Выключить звук": "Silenciar",
  "Медленнее": "Más lento",
  "Обычная": "Normal",
  "Быстрее": "Más rápido",
  "Быстро": "Rápido",
  "{0}: к повторению {1}": "{0}: {1} para repasar",
  "{0}: ничего не запланировано": "{0}: nada programado",
  "{0}: повторено {1}": "{0}: {1} repasadas",
  "{0}: без повторений": "{0}: sin repasos",
  "Предыдущий год": "Año anterior",
  "Следующий год": "Año siguiente",
  "В среднем": "Media diaria",
  "Дней с занятиями": "Días con estudio",
  "Рекорд": "Récord",
  "Серия": "Racha",
  "Проект — нажмите, чтобы повторить только его": "Proyecto — toca para repasar solo este",
  "Повторить «{0}»": "Repasar «{0}»",
  "Повторить карточки": "Repasar tarjetas",
  "Только этот проект": "Solo este proyecto",
  "Скачать карточки (.txt)": "Descargar tarjetas (.txt)",
  "Для Anki и других программ": "Para Anki y otras apps",
  "Отменено": "Deshecho",
  "{0} забанен навсегда": "{0} expulsado para siempre",
  "{0}: тайм-аут {1}": "{0}: suspensión {1}",
  "на день": "por un día",
  "на {0} дней": "por {0} días",
  "Разбанить": "Quitar el bloqueo",
  "{0} разбанен": "{0} desbloqueado",
  "Тайм-аут на день": "Suspender un día",
  "Тайм-аут на 7 дней": "Suspender 7 días",
  "Забанить навсегда": "Bloquear para siempre",
  "Бан с причиной…": "Bloquear con motivo…",
  "Причину увидит пользователь": "El usuario verá el motivo",
  "{0} выкинут со всех устройств": "{0} desconectado de todos los dispositivos",
  "Тариф: сделать Pro": "Plan: hacer Pro",
  "{0} теперь админ": "{0} ahora es administrador",
  "Отменить": "Deshacer",
  "Удалить аккаунт": "Eliminar cuenta",
  "Удалить аккаунт {0}?": "¿Eliminar la cuenta {0}?",
  "Удалятся все его аудио, карточки, тексты, словарь и статистика. Вернуть будет нельзя.": "Se eliminarán todos sus audios, tarjetas, textos, vocabulario y estadísticas. No se puede deshacer.",
  "Удалить навсегда": "Eliminar para siempre",
  "Сейчас повторять нечего": "Ahora no hay nada que repasar",
  "На сегодня всё!": "¡Todo listo por hoy!",
  "Цель на сегодня выполнена!": "¡Objetivo de hoy cumplido!",
  "Подход готов!": "¡Ronda terminada!",
  "Повторено: {0}": "Repasadas: {0}",
  "Карточки, которые вы сейчас учите, вернутся через несколько минут.": "Las tarjetas que estás aprendiendo volverán en unos minutos.",
  "Новые карточки появятся завтра.": "Las tarjetas nuevas llegarán mañana.",
  "Осталось на сегодня: {0} · ≈ {1} мин": "Quedan para hoy: {0} · ≈ {1} min",
  "Всё, что было на сегодня, повторено. Возвращайтесь завтра!": "Todo lo de hoy está repasado. ¡Vuelve mañana!",
  "Хватит на сегодня": "Suficiente por hoy",
  "Ещё {0}": "{0} más",
  "ещё {0} новых — в следующие дни": "{0} nuevas más — en los próximos días",
  "≈ {0} мин": "≈ {0} min",
  "{0} на сегодня · ≈ {1} мин": "{0} para hoy · ≈ {1} min",
  "План на сегодня выполнен!": "¡El plan de hoy está hecho!",
  "План на сегодня": "Plan de hoy",
  "Меньше новых в день": "Menos nuevas al día",
  "Больше новых в день": "Más nuevas al día",
  "Выполнен": "Hecho",
  "уже пройденные": "ya aprendidas",
  "ещё {0} ждут": "{0} más esperan",
  "из нового": "nuevas",
  "Новых карточек в день": "Tarjetas nuevas al día",
  "Сделано сегодня: {0}": "Hecho hoy: {0}",
  "На сегодня всё — возвращайтесь завтра": "Todo listo por hoy — vuelve mañana",
  "повторить {0} · новых {1}": "repasar {0} · nuevas {1}",
  "Сколько из плана на сегодня уже сделано": "Cuánto del plan de hoy está hecho",
  "Язык, новые в день, повторение": "Idioma, nuevas al día, repaso",
  "Плюс повторение уже пройденных — сколько им пора": "Más el repaso de las aprendidas que tocan",
  "Повторить {0} · новых {1} · ≈ {2} мин": "Repasar {0} · nuevas {1} · ≈ {2} min",
  "Ссылка из письма устарела или уже использована. Нажмите «Забыли пароль?» — придёт новая.": "El enlace del correo caducó o ya se usó. Toca «¿Olvidaste la contraseña?» — llegará uno nuevo.",
  "Вход через Google есть в новой версии приложения. Если вы входили через Google, нажмите «Забыли пароль?»: придёт письмо, задайте пароль — и входите по почте.": "El inicio de sesión con Google está en la nueva versión de la app. Si entrabas con Google, toca «¿Olvidaste la contraseña?»: llegará un correo, crea una contraseña y entra con tu correo.",
  "Пароль задан. Теперь можно входить и по почте с паролем — например, в приложении на телефоне.": "Contraseña creada. Ahora también puedes entrar con tu correo y contraseña — por ejemplo, en la app del teléfono.",
  "Задать пароль": "Crear contraseña",
  "Вы входите через Google — пароля у аккаунта пока нет. Задайте его, чтобы входить и по почте.": "Entras con Google — la cuenta aún no tiene contraseña. Crea una para entrar también con tu correo.",
  "Загрузка идёт в браузере телефона. Когда скачается — откройте файл AntonCards.apk и нажмите «Установить». Ваши данные сохранятся.": "La descarga sigue en el navegador del teléfono. Cuando termine, abre el archivo AntonCards.apk y toca «Instalar». Tus datos se conservan.",
  "К повторению": "Repasar",
  "К повторению: {0}, новых: {1}": "Para repasar: {0}, nuevas: {1}",
  "к повторению": "para repasar",
  "Играть «{0}»": "Reproducir «{0}»",
  "Аудио": "Audio",
  "Аудио с карточками по ходу прослушивания": "Audios con tarjetas creadas mientras escuchas",
  "Все аудио": "Todos los audios",
  "Начните с первого аудио": "Empieza con tu primer audio",
  "Загрузите подкаст, аудиокнигу или запись — и добавляйте карточки прямо во время прослушивания.": "Sube un pódcast, audiolibro o grabación y añade tarjetas mientras escuchas.",
  "Выбрать карточку {0}": "Seleccionar tarjeta {0}",
  "Перемотать к {0}": "Ir a {0}",
  "Убрать A-B": "Quitar A-B",
  "Время": "Tiempo",
  "Выйти на других устройствах?": "¿Cerrar sesión en otros dispositivos?",
  "Здесь вы останетесь в аккаунте.": "Aquí seguirás con la sesión iniciada.",
  "Удалить «{0}»": "Eliminar «{0}»",
  "Удалить «{0}»?": "¿Eliminar «{0}»?",
  "Карточки и статистика останутся.": "Las tarjetas y las estadísticas se conservan.",
  "Язык папки «{0}»": "Idioma de la carpeta «{0}»",
  "Это уберёт перевод, статус и SRS-прогресс.": "Se quitarán la traducción, el estado y el progreso de repaso.",
  "Сдвинуть субтитры?": "¿Desplazar los subtítulos?",
  "Снять выделение": "Quitar la selección",
  "Остановить повтор A–B": "Detener la repetición A–B",
  "Повторять отрезок A–B": "Repetir el tramo A–B",
  "Открепить все": "Desanclar todas",
  "На телефоне нет голоса для этого языка. Его можно добавить в настройках Android: «Синтез речи».": "El teléfono no tiene voz para este idioma. Puedes añadirla en los ajustes de Android: «Síntesis de voz».",
  "Озвучка появится после обновления приложения.": "La pronunciación funcionará tras actualizar la aplicación.",
  "Этот браузер не умеет произносить слова.": "Este navegador no puede pronunciar palabras."
};
export default dict;
